import styled from "styled-components";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  @media (min-width: 1280px) {
    justify-content: center;
  }
`;

export default StyledDiv;
